export const BONUS_PER_DAY = 4;
export const BONUS_PER_DAY_COUNCIL = 100;

export const DISTRIBUTE_BOOST_EVERY_POINTS = 1000;
